import { createRouter, createWebHistory } from 'vue-router'
import FdRoute from './frontDesk/index'
import MgRoute from './middleGround/index'
import BaseRoute from './base'

const allRoutes = [...BaseRoute, ...FdRoute, ...MgRoute]

const router = createRouter({
  history: createWebHistory(),
  routes: allRoutes
})

router.beforeEach((to: any, from, next) => {
  window.document.title = to.meta.title == undefined ? '首页' : to.meta.title
  next()
})

export default router
